import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
  encodeURLParameterValueqlj48e6qtqd4 as encodeURLParameterValue,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UrlDecodedParametersBuilderClass;
function UrlDecodedParametersBuilder() {
  if (UrlDecodedParametersBuilderClass === VOID) {
    class $ {
      constructor(encodedParametersBuilder) {
        this.l57_1 = encodedParametersBuilder;
        this.m57_1 = this.l57_1.r4p();
      }
      i37() {
        return decodeParameters(this.l57_1);
      }
      r4p() {
        return this.m57_1;
      }
      s4p(name) {
        var tmp0_safe_receiver = this.l57_1.s4p(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().h2(collectionSizeOrDefault(tmp0_safe_receiver, 10));
          var _iterator__ex2g4s = tmp0_safe_receiver.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            var tmp$ret$2 = decodeURLQueryComponent(item, VOID, VOID, true);
            destination.i2(tmp$ret$2);
          }
          tmp = destination;
        }
        return tmp;
      }
      m4o(name) {
        return this.l57_1.m4o(encodeURLParameter(name));
      }
      t4p() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.l57_1.t4p();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = decodeURLQueryComponent(item);
          destination.i2(tmp$ret$2);
        }
        return toSet(destination);
      }
      n1() {
        return this.l57_1.n1();
      }
      m4p() {
        return decodeParameters(this.l57_1).m4p();
      }
      w4p(name, value) {
        return this.l57_1.w4p(encodeURLParameter(name), encodeURLParameterValue(value));
      }
      x4p(stringValues) {
        return appendAllEncoded(this.l57_1, stringValues);
      }
      n4p(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
        var _iterator__ex2g4s = values.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = encodeURLParameterValue(item);
          destination.i2(tmp$ret$2);
        }
        return this.l57_1.n4p(tmp, destination);
      }
      a5() {
        return this.l57_1.a5();
      }
    }
    initMetadataForClass($, 'UrlDecodedParametersBuilder');
    UrlDecodedParametersBuilderClass = $;
  }
  return UrlDecodedParametersBuilderClass;
}
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.i37();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.t4p().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.s4p(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = encodeURLParameterValue(item);
      destination.i2(tmp$ret$4);
    }
    _this__u8e3s4.n4p(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.t4p().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.s4p(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.i2(tmp$ret$4);
    }
    _this__u8e3s4.n4p(tmp, destination);
  }
}
//region block: exports
export {
  UrlDecodedParametersBuilder as UrlDecodedParametersBuilder18hwlye3pykgz,
  encodeParameters as encodeParameters1kx5voquz3xxo,
};
//endregion

//# sourceMappingURL=UrlDecodedParametersBuilder.mjs.map
